import { css } from '@emotion/core';

const customInputContainerStyles = css`
  display: flex;
`;

const inputContainerStyles = css`
  flex-grow: 1;
`;

const inputStyleOverrides = css`
  border-style: none;

  &:focus {
    border-style: none;
    box-shadow: none;
  }
`;

const tooltipStyleOverrides = css`
  margin-top: -1px;
  right: 6px;
  z-index: 3;
`;

export {
  customInputContainerStyles,
  inputContainerStyles,
  inputStyleOverrides,
  tooltipStyleOverrides,
};
